export function getEnvironmentVariablesHandler() {
  let result = {};

  if (window.location.hostname.includes('fly2work.tui-dx.com')) {
    result = {
      apiBaseUrl: 'https://prod.api.tui/corporate/employee/fly2work/',
      apiGpxBaseUrl: 'https://prod.api.tui/corporate/employee/placement/api/',
      environment: 'prod',
    };
  } else if (window.location.hostname.includes('fly2work.pre.tui-dx.com')) {
    result = {
      apiBaseUrl: 'https://pre-prod.api.tui/corporate/employee/fly2work/',
      apiGpxBaseUrl: 'https://pre-prod.api.tui/corporate/employee/placement/api/',
      environment: 'pre',
    };
  } else if (window.location.hostname.includes('fly2work-web.test.tui-dx.com')) {
    result = {
      apiBaseUrl: 'https://test.api.tui/corporate/employee/fly2work/',
      apiGpxBaseUrl: 'https://test.api.tui/corporate/employee/placement/api/',
      environment: 'test',
    };
  } else if (window.location.hostname.includes('localhost')) {
    result = {
      apiBaseUrl: 'http://localhost:5010/',
      apiGpxBaseUrl: 'http://localhost:5000/api/',
      environment: 'localhost',
    };
  } else {
    result = {
      apiBaseUrl: 'unknown',
      apiGpxBaseUrl: 'unknown',
      environment: 'unknown',
    };
  }
  result.version = 'VERSION';
  return result;
}
